const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Service for handling assessment charts
 * @argument {Application} Application defines the Application service
 * @argument {$q} $q defines the $q service
 */
app.factory('AssessmentCharts', ['Application', 'Authorization', 'AssessmentHost', 'AssessmentLib', function (Application, Authorization, AssessmentHost, AssessmentLib) {


  function rubricData (id, rubric, rubricQuestions) {
    var info = {
      data: [],
      labels: [],
      overview_data: null,
      activeQuestionValue: 0,
      totalAverage: null,
      rubricUserData: null,
      names: [],
      mean_values: [],
      rubric_ids: [],
      rubric_specific_distribution: {},
      trackDisplay: false
    };

    return AssessmentHost.rubricChart({subresource: id, subsubname: rubric}).$promise
    .then(function(data) {
      if (data.score_totals && data.score_totals.variance) {
        info.trackDisplay = true;
      }
      info.overview_data = data.overview_data;

      if (!data.score_totals || !data.score_totals.mean) {
        return null;
      }
      info.totalAverage = Math.round(data.score_totals.mean);

      for (var i = 0; i < rubricQuestions.length; i++) {
        if (rubricQuestions[i] && rubricQuestions[i].id === rubric) {
          info.activeQuestionValue = AssessmentLib.helpers.getQuestionValue(rubricQuestions[i]);
        }
      }
      var averageTotalScore = 0;
      info.rubricUserData = data.user_scores;
      if (data && data.rubric_totals) {
        for (var key in data.rubric_totals) {
          if (data.rubric_totals && data.rubric_totals[key] && (data.rubric_totals[key].mean || data.rubric_totals[key].mean === 0) && data.rubric_totals[key].name) {
            var averageRubricScore = 0;
            info.names.push(data.rubric_totals[key].name);
            info.mean_values.push(data.rubric_totals[key].mean);
            info.rubric_ids.push(key);
            info.data.push({
              mean: data.rubric_totals[key].mean,
              deviation: data.rubric_totals[key].deviation,
              variance: data.rubric_totals[key].variance
            });
            if (data.rubric_totals[key].currentValue) {
              averageRubricScore = Math.round(parseInt(data.rubric_totals[key].mean) / 100 * parseInt(data.rubric_totals[key].currentValue) * 10) / 10;
            }
            info.labels.push({
              name: data.rubric_totals[key].name,
              value: data.rubric_totals[key].currentValue,
              id: key,
              average_score: averageRubricScore
            });
          }
        }
        if (data.rubric_totals[key].currentValue) {
          averageTotalScore = Math.round(parseInt(data.score_totals.mean) / 100 * parseInt(info.activeQuestionValue) * 10) / 10;
        }
        info.data.push(data.score_totals);
        info.labels.push({
          name: 'Question Total',
          value: info.activeQuestionValue,
          id: key,
          average_score: averageTotalScore

        });
      }
      return info;
    });
  };

  function standardData (id) {
    var info = {
      data: [],
      labels: [],
      showStandard: false,
      overview_data: null,
      trackDisplay: false
    };

    return AssessmentHost.standardChart({subresource: id}).$promise
    .then(function(results) {
      info.overview_data = results.overview_data;
      if (results.userScores && results.userScores.length) {
        info.trackDisplay = true;
      }
      var data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var checker = [[0, 10], [10, 20], [20, 30], [30, 40], [40, 50], [50, 60], [60, 70], [70, 80], [80, 90], [90, 100]];
      var labels = ['0-10', '10-20', '20-30', '30-40', '40-50', '50-60', '60-70', '70-80', '80-90', '90-100'];
      var totalNumberScores = 0;

      // Uncomment to create mock data for testing
      // for (var i = 0; i < 100; i++) {
      //   results.userScores.push(Math.random() * 100);
      // }

      results.userScores.forEach(function(score) {
        if (!score && score !== 0) {
          return;
        }

        totalNumberScores++;

        if (score === 100) {
          data[9]++;
          return;
        }

        checker.forEach(function(tuple, index) {
          if (score >= tuple[0] && score < tuple[1]) {
            data[index]++
          }
        });
      });

      info.data.push(data);
      info.labels = labels;

      if (totalNumberScores) {
        info.showStandard = true;
      }

      return info;
    });
  };

  return {
    rubricData: rubricData,
    standardData: standardData
  };

}]);